import { FormControl, FormDescription, FormItem, FormMessage, useFormField } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { SwitchInput } from "../inputs/switch-input"

interface SwitchFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof SwitchInput>, "checked" | "onChange" | "id"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function SwitchField<T extends FieldValues>({ field, id, description, ...props }: SwitchFieldProps<T>) {
  const { error } = useFormField()

  return (
    <FormItem>
      <FormControl>
        <SwitchInput id={id} checked={field.value} onChange={field.onChange} error={!!error} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  notifications: boolean;
}

<FormField
  control={form.control}
  name="notifications"
  render={({ field }) => (
    <SwitchField<FormData>
      field={field}
      id="notifications"
      label="Email Notifications"
      description="Receive email updates about your account"
    />
  )}
/>
*/
